import { useState, useEffect } from 'react';

async function fetchUserLogin(): Promise<string> {
  if (import.meta.env.DEV) return import.meta.env.VITE_USER_LOGIN || 'dev-user';
  try {
    const siteUrl = window.location.origin;
    const params = new URLSearchParams({ client_id: siteUrl, nonce: String(Date.now()), redirect_uri: siteUrl, response_type: 'id_token', scope: 'openid' });
    const response = await fetch(`https://midway-auth.amazon.com/SSO?${params}`, { credentials: 'include' });
    const token = await response.text();
    if (!token || token.split('.').length !== 3) return '';
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return payload.sub || '';
  } catch {
    return '';
  }
}

export function useCurrentUser() {
  const [userAlias, setUserAlias] = useState('');

  useEffect(() => {
    fetchUserLogin().then(setUserAlias);
  }, []);

  return userAlias;
}
